import { toPascalCaseAndUriEncode } from "./utils";

export function getImpactPageUrl({
  frontendUrl,
  impactPageRootPath,
  sqid,
  name,
}: {
  frontendUrl: string;
  impactPageRootPath: string;
  sqid: string;
  name: string;
}): string {
  return `${frontendUrl}${impactPageRootPath}/${sqid}/${toPascalCaseAndUriEncode(name)}`;
}
